module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/polygon-410b6dd24ea2638ab074bf1a5deb965e.svg";